export const DEFAULT_ORGANIZATION = {
  id: "team-readyfit",
  name: "Team ReadyFit",
  branch: "all",
};
